import React from 'react'
import '../../../style/itemDropdown.scss'
import getQualityName from '../../../utils/getQualityName'

function ItemQualities({gate,setQuality,setGate,type}) {
    const qualities=[1,2,3,4,5]


  function closeQualityDropdown(value){
      if(type){
        setGate(true)
        setQuality(type,value)
        return
      }
      setGate(true)
      setQuality(value)
  }
    return (
    <>
        <div className={`dropdownCloser ${gate && "hidden"}`} onClick={()=>setGate(true)}></div>
          <div className={`searchOptionSelections qualities ${gate && "hidden"}`}>
            {qualities.map((quality)=>(<p className={`quality${quality} option`} onClick={()=>{closeQualityDropdown(quality)}}>{getQualityName(quality)}</p>))}
          </div>
      </>
  )
}

export default ItemQualities;